import React from 'react'
import PropTypes from 'prop-types'

function FDICDisclosure({ odsType, alt, data }) {
  return (
    <div className="container__inner">
      <div className="prescreen-notice__fdic-member">
        <img
          className="prescreen-notice__fdic-member__img"
          src={require('../assets/images/ods/FDIC_Member.png')}
          alt="FDIC Member"
        />
        <span className="prescreen-notice__fdic-member__vl" />
        <div className="prescreen-notice__fdic-member__text">
          <p>
            <strong>
              {alt
                ? '^ See the Bottom of this Page for Important Information on Rates, Fees, Costs, and Terms of This Offer'
                : 'See Important Disclosure and Terms of This Offer at the bottom of the page'}
            </strong>
          </p>
          <p>Avant branded credit products are issued by WebBank, Member FDIC.</p>
        </div>
      </div>
      <div
        className={`prescreen-notice__text-box${
          odsType === 'Loan' ? ' prescreen-notice__text-box--alt' : ''
        }`}
      >
        <p className="prescreen-notice__text">
          <strong>
            You can choose to stop receiving &quot;prescreened&quot; offers of credit from Avant,
            WebBank, and other companies by calling toll-free 1-888-567-8688. SCROLL DOWN TO SEE
            PRE-SCREEN &amp; OPT-OUT NOTICE FOR MORE INFORMATION ABOUT PRESCREENED OFFERS.
          </strong>
        </p>
      </div>
      {odsType === 'Loan' && (
        <p className="prescreen-notice__fdic-member__text">
          ^ By submitting an application, you represent that you do not currently hold and have not
          held a payday loan during the previous twelve (12) months. A payday loan may include a
          loan with a short term (&lt; 12 months), high cost (&gt; 100% APR), and / or small balance
          (&lt;$300).
        </p>
      )}
      {data.extras && data.extras.indexOf('Included no payday loan statement') > -1 && (
        <p className="prescreen-notice__fdic-member__text-center">
          By submitting an application, you represent that you do not currently hold and have not
          held a payday loan during the previous twelve (12) months. A payday loan may include a
          loan with a short term (&lt; 12 months), high cost (&gt; 100% APR), and / or small balance
          (&lt;$300).
        </p>
      )}
    </div>
  )
}

FDICDisclosure.defaultProps = {
  alt: false,
  data: {}
}

FDICDisclosure.propTypes = {
  odsType: PropTypes.string.isRequired,
  alt: PropTypes.bool,
  data: PropTypes.object
}

export default FDICDisclosure
